import {
  BackgroundColor,
  Height,
  InputBorder,
  InputFocus,
} from 'module/ui/components/atoms/input/input';
import styled from 'styled-components';
import { FilterBoxWrapper } from '../../components/common';
import { FilterCriteriaWrapper } from '../../components/common';
import { Fields, Select } from '../../criteria/components';

export const FilterWrapper = styled(FilterBoxWrapper)`
  height: 100%;

  ${FilterCriteriaWrapper} {
    max-height: 90%;
  }
  ${Fields} {
    ${BackgroundColor};
    ${InputBorder};
    ${Height};
    padding-left: 0;
    &.ant-select-open {
      ${InputFocus};
      .ant-select-selection-item {
        color: var(--gray-100);
      }
    }
    .ant-select-selector {
      ${Height};
      display: flex;
      align-items: center;
      padding-left: var(--spacing-05);
    }
  }
  ${Select} {
    padding-left: 0;
    .ant-select-selector {
      padding-left: var(--spacing-05);
    }
  }
`;
